import React from 'react'
import { Link } from 'react-router-dom'

const Contact = () => {
    return (
        <>
            <section id="location" className="map-location-main-block">
                <div className="container">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115388.45928299891!2d74.47583742129713!3d25.341493678755352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3968c2368c070a55%3A0xc92f70a42dcb5294!2sBhilwara%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1701419553761!5m2!1sen!2sin" />
                    <div className="contact-main-block">
                        <div className="row">
                            <div className="col-lg-4 col-md-4">
                                <div className="contact-block">
                                    <div className="contact-icon">
                                        <i className="flaticon-location" />
                                    </div>
                                    <div className="contact-dtls">
                                        <h3 className="contact-title">Address</h3>
                                        <p>4517 Washington Ave. Manchester, Kentucky 39495</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="contact-block">
                                    <div className="contact-icon">
                                        <i className="flaticon-telephone" />
                                    </div>
                                    <div className="contact-dtls">
                                        <h3 className="contact-title">Lets Talk us</h3>
                                        <ul>
                                            <li>
                                                Phone number:{" "}
                                                <Link to="tel:+32566 - 800 - 890">+32566 - 800 - 890</Link>
                                            </li>
                                            <li>Fax: 1234 -58963 - 007</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="contact-block">
                                    <div className="contact-icon">
                                        <i className="flaticon-message" />
                                    </div>
                                    <div className="contact-dtls">
                                        <h3 className="contact-title">Send us email</h3>
                                        <ul>
                                            <li>
                                                <Link to="mailto:demo0023yourmailhotmail.com">
                                                    demo0023yourmailhotmail.com
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="mailto:demo23yourmail.com">demo23yourmail.com</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Contact
